import { tns } from 'tiny-slider/src/tiny-slider.module';
import Component from '../../../scripts/utilities/component';

class PlayerCarousel extends Component {
    componentDidMount() {
        this.mq = window.matchMedia('screen and (min-width: 992px)');
        this.nav = this.mount.querySelector('.squad-stats__players-nav');

        if (this.mq.matches) {
            this.initCarousel();
        }

        this.attachListeners();
    }

    attachListeners() {
        this.mq.addListener(this.handleMq.bind(this));
    }

    handleMq(event) {
        if (event.matches) {
            this.initCarousel();
        } else {
            this.destroyCarousel();
        }
    }

    initCarousel() {
        let maxNumberOfSlides = 6;
        const numberOfItems = this.root.children.length;

        if (numberOfItems < maxNumberOfSlides) {
            maxNumberOfSlides = numberOfItems;
        }

        this.carousel = tns({
            container: this.root,
            controlsContainer: this.nav,
            items: maxNumberOfSlides,
            loop: false,
            nav: false,
            slideBy: 'page'
        });
    }

    destroyCarousel() {
        this.carousel.destroy();
    }
}

export default PlayerCarousel;



// WEBPACK FOOTER //
// ./components/eng-ms-squad-stats/scripts/player-carousel.js